<div class="row">
  <div class="col" *ngIf="profileDetail || customerDetail">
    <div class="row justify-content-center" [ngClass]="hideFields ? 'mt-5' : ''">
      <!-- region Balance -->
      <div class="col-lg-10 col-md-12 bg-primary d-flex flex-row justify-content-center align-items-center mb-4 available-money" *ngIf="!hideFields">
        <div class="d-flex flex-column justify-content-center align-items-center ml-3">
          <p class="text-white mt-2">{{ "accounts.balance.available_money" | translate }}</p>
          <h1 class="text-white">{{((balance && balance <= 0) ? 0 : balance) | currency:'$':'symbol':'1.2':'en'}}</h1>
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center ml-4 call-to-action" (click)="refreshBalance()">
          <i class="fas fa-redo text-white"></i>
        </div>
      </div>
      <!-- endregion Balance -->
      <!-- region Notifications -->
      <div class="col-12">
        <app-balance-notifications *ngIf="!hideFields" [profileDetail]="this.profileDetail" [configuration]="this.configuration" [familyHealthService]="this.familyHealthService" [emailValidation]="this.emailValidationDialog"></app-balance-notifications>
      </div>
      <!-- endregion Notifications -->
      <div class="col-12 mb-4 d-flex flex-column flex-md-row flex-lg-row flex-xl-row justify-content-center align-items-center">
        <!-- CARD -->
        <div class="col-md-6 col-lg-6 col-xl-6">
          <div>
            <div class="panel">
              <div [ngClass]="{'card-img__active_card' : profileDetail?.mediaAccessStatus === eMediaAccessStatus.ACTIVE , 'card-img__inactive_card' : profileDetail?.mediaAccessStatus != eMediaAccessStatus.ACTIVE, 'card-img__text_stroked': this.cardTextStroked, 'card-img__bordered': borderCard, 'card-img__text-white': textWhiteCard }" class="card-img card-img--front" [ngStyle]="{'filter' : !hideFields ? '' : 'blur(3px)', 'user-select': !hideFields ? '' : 'none'}" >

                <div class="d-flex">
                  <div *ngIf="profileDetail?.mediaAccessStatus === eMediaAccessStatus.ACTIVE" class="card-img__number">{{ cardNumber | mask : '0000 0000 0000 0000' }}</div>
                  <div class="d-flex flex-row justify-content-center align-items-center cursor-ponter-class" (click)="copyCardNumber()">
                    <i *ngIf="profileDetail?.mediaAccessStatus === eMediaAccessStatus.ACTIVE" class="far fa-copy card-img__copy"></i>
                    <p *ngIf="profileDetail?.mediaAccessStatus === eMediaAccessStatus.ACTIVE" class="card-copy-text" [style]="{'font-size': this.cardTextStroked ? '17.25px' : '11px' }">{{ "accounts.balance.copy" | translate }}</p>
                  </div>
                </div>
                <div *ngIf="profileDetail?.mediaAccessStatus === eMediaAccessStatus.ACTIVE" class="card-img__owner">
                  {{this.profileDetail?.cardName}}
                </div>
                <div class="d-flex flex-row" *ngIf="profileDetail?.mediaAccessStatus === eMediaAccessStatus.ACTIVE">
                  <div>
                    <div *ngIf="profileDetail?.mediaAccessStatus === eMediaAccessStatus.ACTIVE" class="card__data_unblock">
                      <p class="card_data_letter">MM/YY</p>
                      <p class="card_data_letter">CVV</p>
                    </div>
                    <div *ngIf="profileDetail?.mediaAccessStatus === eMediaAccessStatus.ACTIVE" class="d-flex">
                      <div class="card-img__expiry-date">{{displaySensitiveData ? (cardData.expirationDate | date:'MM/yy') : '●●/●●'}}</div>
                      <div class="card-img__cvv">{{displaySensitiveData ? (cardData.cvv) : '●●●' }}</div>
                    </div>
                  </div>
                  <div *ngIf="profileDetail?.mediaAccessStatus === eMediaAccessStatus.ACTIVE && customerDetail?.mediaAccess?.status === eMediaAccessStatus.ACTIVE" class="view-sensitive-data" (click)="viewSensitiveData();">
                    <i class="text-primary" [ngClass]="!displaySensitiveData ? 'fas fa-eye-slash text-danger fa-lg':'fas fa-eye text-success fa-lg'"></i>
                    <p class="view-data-btn" *ngIf="!displaySensitiveData"><u>{{ "accounts.balance.view_data" | translate }}</u></p>
                    <p class="view-data-btn" *ngIf="displaySensitiveData"><u>{{ "accounts.balance.hide_data" | translate }}</u></p>
                  </div>
                </div>
                <!--Sensitive data when card is locked-->
                <div class="d-flex flex-column card__data_locked" *ngIf="profileDetail?.mediaAccessStatus === eMediaAccessStatus.LOCKED">
                  <p class="card_data_locked_icon"><p class="card-lock"><i class="fas fa-lock fa-2x"></i></p>
                  <p>{{ "accounts.balance.card_is_blocked" | translate }}</p>
                </div>
                <img *ngIf="profileDetail?.mediaAccessStatus === eMediaAccessStatus.ACTIVE" class="card-img__logo" height="37.5" src="assets/images/mastercard.png"/>
              </div>
            </div>
            <div class="col-12 mt-2 text-center">
              <div class="form-group" *ngIf="hideFields">
                <small class="m-0 p-0">{{ "accounts.balance.creating_account_info" | translate }}</small>
              </div>
            </div>
          </div>
        </div>
        <!-- Table Account Data -->
        <div class="col-md-6 col-lg-4 col-xl-4 margin-container-small" *ngIf="!hideFields">
          <table class="table info-table">
            <tbody>

            <tr class="call-to-action alert-warning" *ngIf="profileDetail?.mediaAccessStatus === eMediaAccessStatus.ACTIVE  && !customerProfileService.getPinAvailable() && configuration.enablePinReset" (click)="openModal(nipCreation, eModalSize.MD)">
              <td><i class="far fa-keyboard"></i></td>
              <td class="d-flex flex-column">
                <p class="card-label-text">{{ "accounts.balance.create_nip" | translate }}</p>
                <p class="text-muted card-data-text">{{ "accounts.balance.create_nip_sub" | translate }}</p>
              </td>
              <td>
                <div class="d-flex flex-row justify-content-center align-items-center">
                  <i class="far fa-copy fa-hand-pointer"></i>
                  <p class="ml-1 card-data-text">{{ "accounts.balance.click_here" | translate }}</p>
                </div>
              </td>
            </tr>

            <tr class="call-to-action" (click)="copyRoutingNumber()">
              <td><i class="far fa-list-alt"></i></td>
              <td class="d-flex flex-column">
                <p class="card-label-text">073972181</p>
                <p class="text-muted card-data-text">{{ "accounts.balance.routing_number" | translate }}</p>
              </td>
              <td>
                <div class="d-flex flex-row justify-content-center align-items-center">
                  <i class="far fa-copy copy_account_info"></i>
                  <p class="ml-1 card-data-text">{{ "accounts.balance.copy" | translate }}</p>
                </div>
              </td>
            </tr>

            <tr class="call-to-action" (click)="copyAccountNumber()" *ngIf="customerDetail?.accounts[0].accountNumber">
              <td><i class="fas fa-university"></i></td>
              <td class="d-flex flex-column">
                <p class="card-label-text">{{customerDetail?.accounts[0].accountNumber}}</p>
                <p class="text-muted card-data-text">{{ "accounts.balance.account_no" | translate }}</p>
              </td>
              <td>
                <div class="d-flex flex-row justify-content-center align-items-center">
                  <i class="far fa-copy copy_account_info"></i>
                  <p class="ml-1 card-data-text">{{ "accounts.balance.copy" | translate }}</p>
                </div>
              </td>
            </tr>

            <tr *ngIf="profileDetail?.mediaAccessStatus && profileDetail?.pinAvailable">
              <td><i class="far fa-credit-card"></i></td>
              <td><p class="card-label-text">{{ "accounts.balance.status" | translate }}</p></td>
              <td class="text-center">
                <small *ngIf="profileDetail?.mediaAccessStatus == eMediaAccessStatus.ACTIVE" class="mt-n2 p-1 text-white card-active"><b class="small-font-status">{{ "accounts.balance.active" | translate }}</b></small>
                <small *ngIf="profileDetail?.mediaAccessStatus == eMediaAccessStatus.INACTIVE" class="mt-n2 p-1 text-black card-not-active"><b class="small-font-status">{{ "accounts.balance.inactive" | translate }}</b></small>
                <small *ngIf="profileDetail?.mediaAccessStatus == eMediaAccessStatus.REJECTED" class="ml-2 p-1 text-white card-rejected"><b class="small-font-status">{{ "accounts.balance.rejected" | translate }}</b></small>
                <small *ngIf="profileDetail?.mediaAccessStatus == eMediaAccessStatus.CANCELLED" class="ml-2 p-1 text-white card-rejected"><b class="small-font-status">{{ "accounts.balance.canceled" | translate }}</b></small>
                <small *ngIf="profileDetail?.mediaAccessStatus == eMediaAccessStatus.BLOCKED" class="ml-2 p-1 text-white card-rejected"><b class="small-font-status">{{ "accounts.balance.blocked" | translate }}</b></small>
                <small *ngIf="profileDetail?.mediaAccessStatus == eMediaAccessStatus.LOCKED" class="ml-2 p-1 text-black card-not-active"><b class="small-font-status">{{ "accounts.balance.suspended" | translate }}</b></small>
              </td>
            </tr>

            <tr *ngIf="configuration.hasCardBlocking && profileDetail?.customerStatus === eCustomerStatus.ACTIVE && ((customerProfileService?.getPinAvailable() && configuration.enablePinReset) || !configuration.enablePinReset) && (profileDetail?.mediaAccessStatus === eMediaAccessStatus.LOCKED || profileDetail?.mediaAccessStatus === eMediaAccessStatus.ACTIVE)">
              <td>
                <i *ngIf="profileDetail?.mediaAccessStatus === eMediaAccessStatus.LOCKED" class="fas fa-lock"></i>
                <i *ngIf="profileDetail?.mediaAccessStatus === eMediaAccessStatus.ACTIVE && customerDetail?.mediaAccess" class="fas fa-unlock"></i>
              </td>
              <td>
                <p class="card-label-text" *ngIf="checked">{{ "accounts.balance.active_card" | translate }}</p>
                <p class="card-label-text" *ngIf="!checked">{{ "accounts.balance.inactive_card" | translate }}</p>
              </td>
              <td class="text-center">
                <p-inputSwitch class="activation-switch" [(ngModel)]="checked" (onChange)="blockCard()"></p-inputSwitch>
              </td>
            </tr>

            <!-- Card Purchase option -->
            <tr *ngIf="!profileDetail.physicalCardRequested && configuration.hasCardPurchase" class="call-to-action" (click)="getCardPrice();">
              <td>
                <i class="fas fa-shopping-cart"></i>
              </td>
              <td>
                <p *ngIf="this.configuration.cardPurchaseType == eCardPurchaseType.DEFAULT || this.configuration.cardPurchaseType == eCardPurchaseType.ON_LOAD_BY_REQUEST; else onDemandButton" class="card-label-text" >{{ "accounts.balance.card_purchase.title_request" | translate }}</p>
                <ng-template #onDemandButton>
                  <p class="card-label-text" >{{ "accounts.balance.card_purchase.title" | translate }}</p>
                </ng-template>
              </td>
              <td class="text-center">
                <div class="d-flex flex-row justify-content-center align-items-center">
                  <i class="far fa-copy fa-hand-pointer"></i>
                  <p class="ml-1 card-data-text">{{ "accounts.balance.click_here" | translate }}</p>
                </div>
              </td>
            </tr>

            <tr *ngIf="profileDetail && this.configuration.enablePinValidate" class="call-to-action" (click)="openModal(nipValidation, eModalSize.MD);">
              <td><i class="far fa-keyboard"></i></td>
              <td>
                <p class="card-label-text">{{ "accounts.balance.pin_validation" | translate }}</p>
              </td>
              <td class="text-center"><i class="fas fa-hand-pointer"></i></td>
            </tr>

            </tbody>
          </table>
        </div>
        <div class="form-group" *ngIf="hideFields">
          <h4 class="mb-0 pb-0 mt-1"><b>{{ "accounts.balance.creating_account" | translate }}</b></h4>
        </div>
      </div>
    </div>
    <br>
    <h5>{{ "accounts.balance.resolution_title" | translate }}</h5>
    <p class="small translate-new-line">{{ "accounts.balance.resolution_procedure" | translate }}</p>
  </div>
</div>

<!-- NIP VALIDATION -->
<ng-template #nipValidation let-modal>
  <div>
    <div class="modal-header">
      <h4>{{ "accounts.balance.pin_validation" | translate }}</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body justify-content-center text-center">
      <p>{{ "accounts.balance.pin_validation_instructions" | translate }}</p>
      <form #formValidateNip="ngForm" (ngSubmit)="formValidateNip.form.valid && validateNip()" [matchNip]="['pinValue', 'confirmPinValue']">
        <div class="row justify-content-center">
          <div class="col-12">
            <label>PIN</label>
            <div class="input-group">
              <div class="input-group-append">
                <button class="btn btn-outline-success rounded-left" type="button" *ngIf="qaPINValidation"
                        (click)="qaPINValidation = false"><i class="fas fa-eye"></i></button>
                <button class="btn btn-outline-primary rounded-left" type="button" *ngIf="!qaPINValidation"
                        (click)="qaPINValidation = true"><i class="fas fa-eye-slash"></i></button>
              </div>
              <input [type]="qaPINValidation ? 'text' : 'password'" class="form-control" name="pinValue"
                     [(ngModel)]="pin" #pinValue="ngModel" maxlength="4" minlength="4"
                     [ngClass]="inputFieldCss(pinValue, formValidateNip)" numbers required>
            </div>
            <div>
              <label class="float-right mt-2">
                <input type="checkbox" name="newNip" value="nip" [(ngModel)]="qaPINValidation">{{ "accounts.menu.show-nip" | translate }}
              </label>
            </div>
            <app-field-error-display [control]="pinValue" [form]="formValidateNip"></app-field-error-display>
          </div>
          <div class="col-12">
            <label>{{ "accounts.balance.pin_confirm" | translate }}</label>
            <div class="input-group">
              <div class="input-group-append">
                <button class="btn btn-outline-success rounded-left" type="button" *ngIf="qaPINConfirmation"
                        (click)="qaPINConfirmation = false"><i class="fas fa-eye"></i></button>
                <button class="btn btn-outline-primary rounded-left" type="button" *ngIf="!qaPINConfirmation"
                        (click)="qaPINConfirmation = true"><i class="fas fa-eye-slash"></i></button>
              </div>
              <input [type]="qaPINConfirmation ? 'text' : 'password'" class="form-control" name="confirmPinValue"
                     [(ngModel)]="confirmPin" #confirmPinValue="ngModel" maxlength="4" minlength="4"
                     [ngClass]="inputFieldCss(confirmPinValue, formValidateNip)"numbers required>
            </div>
            <div>
              <label class="float-right mt-2">
                <input type="checkbox" name="newNip" value="nip" [(ngModel)]="qaPINConfirmation">{{ "accounts.menu.show-nip" | translate }}
              </label>
            </div>
            <app-field-error-display [control]="confirmPinValue" [form]="formValidateNip"></app-field-error-display>
          </div>
          <div class="btn-group">
            <button type="submit" class="btn btn-outline-primary">{{ "accounts.balance.pin_validate" | translate }}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<!--Dialog to block card-->
<p-dialog header=" " [(visible)]="displayModalBlocked" [modal]="true" [baseZIndex]="10000" [style]="{'width' : '40vh'}" (onHide)="checked = true">
  <div class="d-flex flex-column align-items-center justify-content-center">
    <i class="fas fa-exclamation-triangle fa-2x notification-triangle-icon"></i>
    <p class="text-center" >{{ "accounts.balance.modal_locked_card_1" | translate }}</p>
    <p class="text-center" >{{ "accounts.balance.modal_locked_card_2" | translate }}</p>
  </div>
  <div class="d-flex justify-content-between">
    <button type="button" class="btn btn-outline-primary btn-yesno-width" (click)="displayModalBlocked = false; checked = true">{{ "accounts.balance.no" | translate}}</button>
    <button type="button" class="btn btn-outline-success ml-3 btn-yesno-width" (click)="cardACtivation()" >{{ "accounts.balance.yes" | translate}}</button>
  </div>
</p-dialog>

<!-- Dialog to show referrer settings -->
<p-dialog class="referrer-header" header=" " [(visible)]="showReferrerModal" [modal]="true" [draggable]="false" [resizable]="false">
  <div class="d-flex flex-column align-items-center justify-content-center">
    <i class="fas fa-info-circle fa-2x text-primary"></i>
    <p class="text-center mt-1">{{"accounts.referred.code.no-show-broker-code-pt1" | translate }}<br>{{"accounts.referred.code.no-show-broker-code-pt2" | translate }}<br>{{"accounts.referred.code.no-show-broker-code-pt3" | translate }}</p>
  </div>
</p-dialog>

<!--NIP CREATION-->
<ng-template #nipCreation let-modal>
  <div>
    <div class="modal-header">
      <h4>{{ "accounts.balance.pin_creation" | translate }}</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body justify-content-center text-center">
      <form #formCreateNip="ngForm" (ngSubmit)="formCreateNip.form.valid && resetNip(modal)" [matchNip]="['pinValue', 'confirmPinValue']">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="form-group">
              <label>{{ "accounts.balance.pin_creation_instructions" | translate }}</label>
              <div class="input-group">
                <div class="input-group-append">
                  <button class="btn btn-outline-success rounded-left" type="button" *ngIf="showNewNip"
                          (click)="showNewNip = false"><i class="fas fa-eye"></i></button>
                  <button class="btn btn-outline-primary rounded-left" type="button" *ngIf="!showNewNip"
                          (click)="showNewNip = true"><i class="fas fa-eye-slash"></i></button>
                </div>
                <input [type]="showNewNip ? 'text' : 'password'" class="form-control" name="pinValue"
                       [(ngModel)]="pin" #pinValue="ngModel" maxlength="4" minlength="4"
                       [ngClass]="inputFieldCss(pinValue, formCreateNip)" numbers required>
              </div>
            </div>
            <app-field-error-display [control]="pinValue" [form]="formCreateNip"></app-field-error-display>
            <div>
              <label class="float-right mt-2">
                <input type="checkbox" name="newNip" value="nip" [(ngModel)]="showNewNip">{{ "accounts.menu.show-nip" | translate }}
              </label>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label>{{ "accounts.balance.pin_confirm" | translate }}</label>

              <div class="input-group">
                <div class="input-group-append">
                  <button class="btn btn-outline-success rounded-left" type="button" *ngIf="confirmNip"
                          (click)="confirmNip = false"><i class="fas fa-eye"></i></button>
                  <button class="btn btn-outline-primary rounded-left" type="button" *ngIf="!confirmNip"
                          (click)="confirmNip = true"><i class="fas fa-eye-slash"></i></button>
                </div>
                <input [type]="confirmNip ? 'text' : 'password'" class="form-control" name="confirmPinValue"
                       [(ngModel)]="confirmPin" #confirmPinValue="ngModel" maxlength="4" minlength="4"
                       [ngClass]="inputFieldCss(confirmPinValue, formCreateNip)" numbers required>
              </div>
              <app-field-error-display [control]="confirmPinValue" [form]="formCreateNip"></app-field-error-display>
              <div>
                <label class="float-right mt-2">
                  <input type="checkbox" name="confirm nip" value="nip" [(ngModel)]="confirmNip">{{ "accounts.menu.show-nip" | translate }}
                </label>
              </div>
            </div>
          </div>
          <div class="btn-group">
            <button type="submit" class="btn btn-outline-primary">{{ "accounts.balance.create" | translate }}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<!-- region Card Purchase -->
<p-dialog header=" " [(visible)]="displayCardPurchase" [modal]="true" [baseZIndex]="10000">
  <div class="d-flex align-items-center justify-content-center flex-column">
    <i class="fas fa-exclamation-triangle fa-2x notification-triangle-icon"></i>
    <p *ngIf="this.configuration.cardPurchaseType == eCardPurchaseType.DEFAULT; else onDemandText" class="translate-new-line justify-content-center text-center">{{ "accounts.balance.card_purchase.warning_cost_default" | translate: {data: this.cardPrice} }}</p>
    <ng-template #onDemandText>
      <p class="translate-new-line justify-content-center text-center">{{ "accounts.balance.card_purchase.warning_cost_on_demand" | translate: {data: this.cardPrice} }}</p>
    </ng-template>
  </div>
  <div class="d-flex justify-content-between">
    <button type="button" class="btn btn-outline-primary btn-yesno-width" (click)="displayCardPurchase = false">{{ "accounts.balance.card_purchase.dont_agree" | translate}}</button>
    <button type="button" class="btn btn-outline-success ml-3 btn-yesno-width" (click)="displayCardPurchase = false; displayAddressConfirmation = true;">{{ "accounts.balance.card_purchase.agree" | translate}}</button>
  </div>
</p-dialog>
<!-- endregion Card Purchase -->

<!-- region Address Confirmation for Card Purchase -->
<div class="alert-warning">
  <p-dialog id="addresswarning" [(visible)]="displayAddressConfirmation" [modal]="true" [baseZIndex]="10000" >
    <div class="d-flex align-items-center justify-content-center flex-column ">
      <i class="fas fa-exclamation-triangle fa-2x notification-triangle-icon"></i>
      <h1>{{ "accounts.balance.card_purchase.address_confirm_attention" | translate}}</h1>
      <p>{{ "accounts.balance.card_purchase.address_confirm_send_card1" | translate}}
        <b>{{ "accounts.balance.card_purchase.address_confirm_required" | translate}}</b>
        {{ "accounts.balance.card_purchase.address_confirm_send_card2" | translate}}
        <br>
        <b>{{ "accounts.balance.card_purchase.address_confirm_avoid_send_card" | translate}}</b></p>


      <p>{{ "accounts.balance.card_purchase.address_confirm_example" | translate}}</p>
      <p>{{ "accounts.balance.card_purchase.address_confirm_correct" | translate}}</p>
      <div class="alert shadow-sm" style=" background: white; border-radius: 20px; font-family: 'Roboto Mono', monospace;">
        <p>{{profileDetail?.firstName}} {{profileDetail?.middleName}}
          {{profileDetail?.lastName }} {{profileDetail?.secondLastName}}<br>
          {{customerDetail?.address[0]?.streetName}}<br>
          {{customerDetail?.address[0]?.city}}, {{customerDetail?.address[0]?.state}}, {{customerDetail?.address[0]?.zipcode}}<br>
          UNITED STATES</p>
      </div>
      <div class="card justify-content-center mb-2 p-0 col-6" style="border-color: var(--info); border-radius: 15px">
        <div class="row justify-content-center">
          <i class="fas fa-info-circle fa-2x text-info"></i>
        </div>
        <div class="row justify-content-center text-center">
          <div class="col-10 col-sm-11 justify-content-center align-items-center p-0 m-1">
            <div class="card-body p-0">
              <p class="card-text responsive-small text-info translate-new-line mb-1" style="font-size: 15px">
                {{ "accounts.balance.card_purchase.call_center" | translate: {callCenter: this.configuration.callCenterNumber} }}
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="d-flex justify-content-between " >
      <button type="button" class="btn btn-outline-primary btn-yesno-width" (click)="displayAddressConfirmation = false">{{ "accounts.balance.no" | translate}}</button>
      <button type="button" class="btn btn-outline-success ml-3 btn-yesno-width" (click)="displayAddressConfirmation = false; cardPurchase();">{{ "accounts.balance.yes" | translate}}</button>
    </div>
  </p-dialog>
</div>

<!-- endregion Address Confirmation for Card Purchase -->